<template>
  <input
    ref="rangeSelector"
    :value="range"
    :type="attrs.type"
    :placeholder="attrs.placeholder"
    :class="attrs.class"
    @input="setRange"
  />
</template>
<script>
import { icons } from "../../utils/icons";
import { convertToAbsolute } from "../../utils/util";
import { rangeLabelToIndex, rangeIndexToLabel, sortRange, getCellId } from "../process-design/cell/Utils";
import DesignerMixin from "../process-design/DesignerMixin";

export default {
  name: "RangeSelector",
  components: {},
  mixins: [DesignerMixin],
  props: ["attrs"],

  data() {
    return {
      range: "",
      icons,
    };
  },
  computed: {
    currentActiveTable() {
      return this.$store.state.table.activeTable;
    },
  },
  watch: {
    mainRange(newValue, oldValue) {
      if (this.currentActiveTable) {
        this.range = convertToAbsolute(this.currentActiveTable?.tableRange);
        this.$emit("passRange", this.range);
      } else {
        this.range = convertToAbsolute(rangeIndexToLabel(newValue.range));
        this.$emit("passRange", this.range);
      }
    },
  },
  mounted() {
    this.$refs.rangeSelector.focus();
    if (this.currentActiveTable) {
      this.range = convertToAbsolute(this.currentActiveTable?.tableRange);
      this.$emit("passRange", this.range);
    } else {
      const rangeValue = this.$store.getters["cells/activeRange"]().range;
      this.range = convertToAbsolute(rangeIndexToLabel(rangeValue));
      this.$emit("passRange", this.range);
    }
  },
  methods: {
    setRange(event) {
      this.$emit("passRange", event.target.value);
      this.$store.dispatch("cells/selectFormulaRange", event.target.value);
    },
  },
};
</script>

<style scoped></style>
